// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class OrderType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Types = {
    SalesOrder:1,
    Warranty: 2,
    PartsOrder: 3,
    Winter: 4,
    Quote: 5,
    InvoiceCredit: 6,
    Credit: 7
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  name?: string;
  taxable!: boolean;
}

